import { createFileRoute } from "@tanstack/react-router";

import CotizacionesPage from "@/components/CotizacionesPage";

export interface CotizacionesSearch {
  open?: string;
}

export const Route = createFileRoute("/cotizaciones")({
  validateSearch: (search: Record<string, unknown>): CotizacionesSearch => {
    const open =
      typeof search.open === "string" && search.open.length > 0 ? search.open : undefined;
    return { open };
  },
  component: CotizacionesPage,
});
